import React from "react";
import styled from "styled-components";

const TRIANGLE_HEIGHT = 8;
const BORDER_OFFSET = 2;

const Box = styled.div``;

const Wrapper = styled(Box)`
  display: flex;
  position: relative;
`;

const Toggle = styled(Box)`
  display: flex;
`;

const Container = styled(Box)`
  position: absolute;
  top: ${props => props.offsetHeight}px;
  left: 50%;
  ${props => props.forceLeft ? `transform: translateX(-100%) translateX(${TRIANGLE_HEIGHT}px) !important; ` : `transform: translateX(-50%) translateX(${-props.offsetWidth}px) !important;`}
  display: ${props => (props.visible ? "block" : "none")};
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  z-index: 20;
  ::before,
  ::after {
    position: absolute;
    ${props => props.triangleOrientation === 'bottom' ? `bottom: -${TRIANGLE_HEIGHT}px;` : `top: -${TRIANGLE_HEIGHT}px;`}

    ${props => props.forceLeft ? `left: calc(100% - ${TRIANGLE_HEIGHT}px);` : `left: calc(50% + ${props.offsetWidth}px);`}
    transform: translateX(-50%);
    width: 0;
    height: 0;
    content: "";
    border-left: ${TRIANGLE_HEIGHT}px solid transparent;
    border-right: ${TRIANGLE_HEIGHT}px solid transparent;
    ${props => props.triangleOrientation === 'bottom' ? `border-top: ${TRIANGLE_HEIGHT}px solid ${props.$triangleColor ? props.$triangleColor : 'rgb(255, 255, 255)'};` : `border-bottom: ${TRIANGLE_HEIGHT}px solid ${props.$triangleColor ? props.$triangleColor : 'rgb(255, 255, 255)'};`}

  }
  ::before {
    ${props => props.triangleOrientation === 'bottom' ? `bottom: -${TRIANGLE_HEIGHT + 2}px;` : `top: -${TRIANGLE_HEIGHT + 2}px;`}
    ${props => props.triangleOrientation === 'bottom' ? `border-top: 10px solid rgba(0, 0, 0, 0.15);` : `border-bottom: 10px solid rgba(0, 0, 0, 0.15);`}
  }

  @media all and (-ms-high-contrast: none) {
    position: absolute;
     top: ${props => props.offsetHeight}px;
     left: 50%;
     ${props => props.forceLeft ? `transform: translateX(-100%) translateX(${TRIANGLE_HEIGHT}px) !important; ` : `transform: translateX(-50%) translateX(${-props.offsetWidth}px) !important;`}
     display: ${props => (props.visible ? "block" : "none")};
     background-color: #ffffff;
     box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
     z-index: 20;
     border: 1px solid #cccccc;
     ::before,
     ::after {
       position: absolute;
       ${props => props.triangleOrientation === 'bottom' ? `bottom: -${TRIANGLE_HEIGHT}px;` : `top: -${TRIANGLE_HEIGHT}px;`}
       ${props => props.forceLeft ? `left: calc(100% - ${TRIANGLE_HEIGHT}px) !important;` : `left: calc(50% + ${props.offsetWidth}px) !important;`}
       transform: translateX(-50%);
       width: 0;
       height: 0;
       content: "";
       border-left: ${TRIANGLE_HEIGHT}px solid transparent;
       border-right: ${TRIANGLE_HEIGHT}px solid transparent;
       ${props => props.triangleOrientation === 'bottom' ? `border-top: ${TRIANGLE_HEIGHT}px solid ${props.$triangleColor ? props.$triangleColor : 'rgb(255, 255, 255)'};` : `border-bottom: ${TRIANGLE_HEIGHT}px solid ${props.$triangleColor ? props.$triangleColor : 'rgb(255, 255, 255)'};`}

     }
     ::before {
      ${props => props.triangleOrientation === 'bottom' ? `bottom: -${TRIANGLE_HEIGHT + 2}px;` : `top: -${TRIANGLE_HEIGHT + 2}px;`}
      ${props => props.triangleOrientation === 'bottom' ? `border-top: 10px solid rgba(0, 0, 0, 0.15);` : `border-bottom: 10px solid rgba(0, 0, 0, 0.15);`}
     }
 }
`;

class DropdownMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isTransformed: false,
      triangleOrientation: 'top',
      offsetHeight: 0,
      offsetWidth: 0,
      correctionWidthOffset: props.correctionWidthOffset || 0
    };
    this._isMounted = false;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
    document.addEventListener("touchstart", this.handleOutsideClick);
    this._isMounted = true;
  }

  componentDidUpdate() {
    if (this.toggleElement && !this.state.isTransformed) {
      if (this.props.prioritizeTop) {
        this.setOffsetHeight(-this.containerElement.offsetHeight - TRIANGLE_HEIGHT, 'bottom');
      } else {
        this.setOffsetHeight(this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
      }
    }
    if (
      this.containerElement &&
      !this.props.center &&
      !this.state.isTransformed
    ) {
      this.calculateOffsets();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    document.removeEventListener("touchstart", this.handleOutsideClick);
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
    this._isMounted = false;
  }

  updateStateIfMounted(newState) {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  setWrapperRef = element => {
    this.wrapperElement = element;
  };
  setToggleRef = element => {
    this.toggleElement = element;
  };
  setContainerRef = element => {
    this.containerElement = element;
  };

  setOffsetHeight = (offsetHeight, triangleOrientation) => {
    if (this.state.offsetHeight !== offsetHeight) {
      this.updateStateIfMounted({ offsetHeight, isTransformed: true, triangleOrientation });
    }
  };
  setOffsetWidth = (offsetWidth) => {
    if (this.state.offsetWidth !== offsetWidth) {
      this.updateStateIfMounted({ offsetWidth, isTransformed: true });
    }
  };

  handleCloseElement = element => {
    if (element.dataset.close) {
      element.click();
      this.updateStateIfMounted({ isOpen: false });
    }
  };

  handleOutsideClick = event => {
    if (!this.state.isOpen) {
      return;
    }
    this.handleCloseElement(event.target);
    if (this.toggleElement && !this.wrapperElement.contains(event.target)) {
      this.updateStateIfMounted({ isOpen: false });
    }
  };

  wrapperElement = null;
  toggleElement = null;
  containerElement = null;
  closeTimeout = null;

  toggleMenu = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!this.props.disabled) {
      if (!this.state.isOpen && this.props.closeAfterDelay && !this.props.disabled) {
        if (this.closeTimeout) {
          clearTimeout(this.closeTimeout);
        }
        this.closeTimeout = setTimeout(() => this.updateStateIfMounted({
          isOpen: false, isTransformed: false, offsetHeight: 0,
          offsetWidth: 0,
        }), this.props.closeAfterDelay)
      }

      this.updateStateIfMounted(prevState => ({
        isOpen: !prevState.isOpen, isTransformed: false, offsetHeight: 0,
        offsetWidth: 0,
      }));

      return false;
    }

  };

  calculateOffsets = () => {

    const { left, right, height } = this.containerElement.getBoundingClientRect();
    const { top: topToggle, bottom: bottomToggle } = this.toggleElement.getBoundingClientRect();
    const boundingElementRect = (this.props.boundingElement) ? this.props.boundingElement.getBoundingClientRect() :
      {left: 0, top: 0, right: window.innerWidth , bottom: window.innerHeight};

    const {
      right: rightBound,
      left: leftBound,
      top: topBound,
      bottom: bottomBound,
    } = boundingElementRect;

    if (right > rightBound) {
      let offsetWidth = right - rightBound + BORDER_OFFSET - this.state.correctionWidthOffset;
      this.setOffsetWidth(offsetWidth);
    }
    else if (left < leftBound) {
      let offsetWidth = -Math.abs(leftBound - left - BORDER_OFFSET + this.state.correctionWidthOffset);
      this.setOffsetWidth(offsetWidth);
    }
    if (this.props.prioritizeTop) {
      if ((topToggle - height) < topBound) {
        this.setOffsetHeight(this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
      } else if ((bottomToggle + height) > bottomBound) {
        this.setOffsetHeight(-this.containerElement.offsetHeight - TRIANGLE_HEIGHT, 'bottom');
      }
    } else {
      if (this.props.allowTop) {

        if ((bottomToggle + height) > bottomBound) {
          this.setOffsetHeight(-this.containerElement.offsetHeight - TRIANGLE_HEIGHT, 'bottom');
        } else {
          if ((topToggle - height) < topBound) {
            this.setOffsetHeight(this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
          }
        }
      } else {
        this.setOffsetHeight(this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
      }
    }
  };

  render() {

    let openModuleProps = {
      onClick: this.toggleMenu
    };
    if (this.props.openOnRightClick) {
      openModuleProps = {
        onContextMenu: this.toggleMenu
      }
    }

    return (
      <Wrapper ref={this.setWrapperRef}>
        <Toggle {...openModuleProps} ref={this.setToggleRef}>
          {this.props.toggleElement}
        </Toggle>
        <Container
          visible={this.state.isOpen}
          offsetHeight={this.props.fixedTop ? this.props.fixedTop : this.state.offsetHeight}
          offsetWidth={this.state.offsetWidth}
          offsetWidthTriangle={this.state.offsetWidthTriangle}
          ref={this.setContainerRef}
          forceLeft={this.props.forceLeft}
          triangleOrientation={this.state.triangleOrientation}
          $triangleColor={this.props.triangleColor}
        >
          {this.state.isOpen && this.props.containerElement}
        </Container>
      </Wrapper>
    );
  }
}

export default DropdownMenu;
